import { fetchSubmission } from '@actions/submissions';
import {
    getSubmission,
    getSubmissionsFetchError,
    getSubmissionsIsFetching,
} from '@selectors/submissions';
import { useEffect } from 'react';

import { useDispatch, useSelector } from 'react-redux';
import { RootState } from 'src/redux/reducers';

const useFetchSubmission = (id: number) => {
    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(fetchSubmission(id));
    }, [dispatch, id]);

    const submission = useSelector((state: RootState) => getSubmission(state, id ?? -1)) || {};
    const isFetching = useSelector(getSubmissionsIsFetching);
    const fetchError = useSelector(getSubmissionsFetchError);

    return { submission, isFetching, fetchError };
};

export default useFetchSubmission;
